import React from 'react'

export default function ScriptRemark() {
	return (
		<div>
			<span>Values colored in <span style={{ color: process.env.REACT_APP_SECONDARY_COLOR_CODE }}>blue</span> are calculated by script.</span>
		</div>
	)
}
